"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Lines extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderLine", line => {
      const lineGenerator = this.props.lineGenerator;
      const id = line.id,
            data = line.data,
            color = line.color;
      const className = "line  line--" + id;
      return _react.default.createElement("path", {
        key: id,
        d: lineGenerator(data.map(d => ({
          x: d.position.x,
          y: d.position.y
        }))),
        stroke: color,
        fill: "none",
        className: className
      });
    });
  }

  render() {
    const series = this.props.series;
    return _react.default.createElement("g", {
      className: "lines"
    }, series.map(this.renderLine));
  }

}

var _default = Lines;
exports.default = _default;
module.exports = exports.default;